/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 */

import { createContext, useContext, useState } from 'react';

const Context = createContext({});

const EventMonitoringContextProvider = ({ children }) => {

    const [paramsContext, setParamsContext] = useState(null);

    return (
        <Context.Provider value={{ paramsContext, setParamsContext }}>
            {children}
        </Context.Provider>
    );
};

const useEventMonitoringContextProvider = () => {
    return useContext(Context);
};

export { EventMonitoringContextProvider, useEventMonitoringContextProvider };
